'use client'
import {useEffect, useState} from 'react'

export type TPlatform = 'other' | 'huawei' | 'android' | 'apple'

const getPlatform = (): TPlatform => {
  if (typeof window === 'undefined') {
    return 'other'
  }

  const userAgent = window?.navigator?.userAgent || window?.navigator?.vendor

  if (/huawei/i.test(userAgent)) {
    return 'huawei'
  }

  if (/android/i.test(userAgent)) {
    return 'android'
  }

  if (/iPad|iPhone|iPod|Mac/.test(userAgent)) {
    return 'apple'
  }

  return 'other'
}

export function usePlatform() {
  const [platform, setPlatform] = useState<TPlatform | null>(null)
  useEffect(() => {
    setPlatform(getPlatform())
  }, [])

  return platform
}
